import { render } from "./S98752.vue?vue&type=template&id=027a4389"
const script = {}
script.render = render

export default script